module.exports = __webpack_public_path__ + "img/ilab-logo.266eba9f.png";